import { render, staticRenderFns } from "./MerchantModal.vue?vue&type=template&id=33b2a828&scoped=true&"
import script from "./MerchantModal.vue?vue&type=script&lang=js&"
export * from "./MerchantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2a828",
  null
  
)

export default component.exports